<template>
  <div class="col-action" :style="styleProperty">
    <span v-for="actionName in resolveActionList" :key="actionName">
      <component
        :is="actionName"
        :id="`${actionName}-${resolveTooltip(columnProperties.value)}`"
        :class="`icon-actions ${actionName} mx-1`"
        @click.native="handleAction(columnProperties.value, actionName)"
      />
      <b-tooltip
        :title="'Detail'"
        class="cursor-pointer"
        :target="`${actionName}-${resolveTooltip(columnProperties.value)}`"
      />
    </span>
  </div>
</template>

<script>
import { BTooltip } from "bootstrap-vue";
import { computed } from "@vue/composition-api";
import { actionColumn } from "@/configs/dynamic-config/dynamic-column";
import Detail from "@/@core/components/svg/common/ListMenu.vue";
import Edit from "@/@core/components/svg/common/TableEdit.vue";
import router from "@/router";
export default {
  components: {
    Detail,
    Edit,
    BTooltip,
  },
  props: {
    columnProperties: Object,
  },
  setup(props) {
    const styleProperty = computed(() => ({}));

    const handleAction = (route, actionName) => {
      const routeDetail = route.find((o) => o.type == actionName);
      const queryParams = Object.create({});
      routeDetail.payload.map((o) => {
        queryParams[o.key] = o.value;
      });
      queryParams.mode = actionName;
      router.push({
        path: "/data-management/detail/Customer_Detail",
        query: queryParams,
      });
    };

    const resolveActionList = computed(
      () =>
        props.columnProperties.field.column_property.action_list ||
        actionColumn.action_list
    );

    const resolveTooltip = (value) => value[0].payload[0].value;

    return {
      styleProperty,
      resolveActionList,
      handleAction,
      resolveTooltip,
    };
  },
};
</script>

<style>
svg.icon-actions path {
  fill: #737373;
}
</style>

<style scoped>
.col-action {
  white-space: nowrap;
}

.icon-actions {
  cursor: pointer;
}

.icon-actions.detail {
  width: 20px;
  height: auto;
}

.icon-actions.edit {
  width: 25px;
}

.icon-actions:hover {
  transform: scale(1.1);
}
</style>
